import Modal from "@/components/modal/modal.vue";
import Toggle from "@/components/toggle/toggle.vue";
import SvgRenderer from "@/components/svgRenderer/svgRenderer.vue";
import { createNamespacedHelpers } from "vuex";
import { MyGoalService } from "@/services/myGoalsApi";
import { REQUEST_STATE } from "@/enums";

const { mapGetters: brandingGetters } = createNamespacedHelpers("branding"),
	{ mapGetters: userGetters, mapActions: userActions } = createNamespacedHelpers("user"),
	DIVIDER = 1000;

export default {
	props: {
		requestStateTotal: String,
		weightTotal: Number,
		weightTotalDiff: Number,
		costTotal: Number,
		costTotalDiff: Number,

		requestStateWPG: String,
		weightWPG: Number,
		weightWPGDiff: Number,
		costWPG: Number,
		costWPGDiff: Number,
	},

	components: {
		Modal,
		Toggle,
		SvgRenderer,
	},

	data() {
		return {
			wpgMode: null,
			tooltipContent: "",
			showEditModal: false,
			submitted: false,
			mealW: null,
			co2Eq: null,
			REQUEST_STATE,
		};
	},

	methods: {
		...userActions(["getMe"]),
		diffClass,
		doShowEditModal,
		submit,
	},

	updated() {
		// this.equalizeBoxWidths();
	},

	computed: {
		...brandingGetters(["colors"]),
		...userGetters(["activeOutlet", "mealWeightGr", "CO2EqPerKg", "weightUnit"]),

		weight() {
			const w = this.wpgMode ? this.weightWPG : this.weightTotal;
			return typeof w === "number" ? (w / DIVIDER).toFixed(0) : "-";
		},

		weightDiff() {
			const w = this.wpgMode ? this.weightWPGDiff : this.weightTotalDiff;
			return typeof w === "number" ? (w / DIVIDER).toFixed(0) : "-";
		},

		cost() {
			if (this.wpgMode === null) this.wpgMode = this.costWPG > this.costTotal;

			const c = this.wpgMode ? this.costWPG : this.costTotal;
			return typeof c === "number" ? c.toFixed(0) : "-";
		},

		costDiff() {
			const c = this.wpgMode ? this.costWPGDiff : this.costTotalDiff;
			return typeof c === "number" ? c.toFixed(0) : "-";
		},

		meals() {
			const w = this.wpgMode ? this.weightWPG : this.weightTotal;
			if (w === null) return "-";
			// the weight per meal is in grams, we don't need to divide by 1000
			return (w / this.mealWeightGr).toFixed(0);
		},

		mealsDiff() {
			const w = this.wpgMode ? this.weightWPGDiff : this.weightTotalDiff;
			if (w === null) return "-";
			return (w / this.mealWeightGr).toFixed(0);
		},

		co2() {
			const w = this.wpgMode ? this.weightWPG : this.weightTotal;
			if (w === null) return "-";
			return ((w * this.CO2EqPerKg) / DIVIDER).toFixed(0);
		},

		co2Diff() {
			const w = this.wpgMode ? this.weightWPGDiff : this.weightTotalDiff;
			if (w === null) return "-";
			return ((w * this.CO2EqPerKg) / DIVIDER).toFixed(0);
		},
	},
};

function diffClass(diff) {
	if (diff === "-") return "black";
	return diff < 0 ? "red" : "green";
}

function doShowEditModal() {
	this.mealW = this.mealWeightGr;
	this.co2Eq = this.CO2EqPerKg;
	this.submitted = false;
	this.showEditModal = true;
}

async function submit() {
	this.submitted = true;

	try {
		await MyGoalService.setMealsCO2Settings({
			mealWeightGr: this.mealW,
			CO2EqPerKg: this.co2Eq,
		});

		await this.getMe();

		this.showEditModal = false;
	} catch (error) {
		this.submitted = false;
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}
